/**
 * 串接鉅亨號留言板
 * 點擊留言板內的股票連結時，透過postMessage攔截要導轉的url
 * 取得url內的股票代號(symbol)
 * 傳到TradingView內來實現點擊股票代號，在同一頁更換為點擊的股票線圖
 */
import React, { useEffect, useState } from 'react';

export const useHaoPostMessage = () => {
  const [symbol, setSymbol] = useState(undefined);

  const onHandleMessage = event => {
    if (event.origin === 'https://hao.cnyes.com') {
      const data = JSON.parse(event.data);
      const action = data.action;

      if (action === 'redirect') {
        const arr = data.link.split('/');
        setSymbol(arr[arr.length - 1]);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('message', onHandleMessage);

    return () => {
      window.removeEventListener('message', onHandleMessage);
    };
  }, []);
  return symbol;
};
